import { motion } from 'motion/react'

import { m } from '~/paraglide/messages.js'
import { useParagraphReveal } from '~/components/use-paragraph-reveal'

const revealSteps = [
  { selector: '[data-a="1"]', at: 1 },
  { selector: '[data-a="2"]', at: 2 },
  { selector: '[data-a="3"]', at: 3 },
  { selector: '[data-a="4"]', at: 4 },
  { selector: '[data-a="5"]', at: 5 },
] as const

export function Page3Content({
  revealed,
  skipNonce,
  onRevealsComplete,
}: {
  revealed: boolean
  skipNonce: number
  onRevealsComplete?: () => void
}) {
  const { scope } = useParagraphReveal({
    enabled: revealed,
    skipNonce,
    onComplete: onRevealsComplete,
    steps: revealSteps,
  })

  return (
    <motion.div
      ref={scope}
      className="flex w-full flex-1 flex-col justify-center gap-6 pb-6 text-white"
      exit={{ opacity: 0, transition: { duration: 0.3 } }}
    >
      <p data-a="1" style={{ opacity: 0 }}>
        {m.pro_user_appreciation_letter_bald_cypress_body1()}
      </p>
      <p data-a="2" className="whitespace-pre-line" style={{ opacity: 0 }}>
        {m.pro_user_appreciation_letter_bald_cypress_body2()}
      </p>
      <p data-a="3" className="whitespace-pre-line" style={{ opacity: 0 }}>
        {m.pro_user_appreciation_letter_bald_cypress_body3()}
      </p>
      <p data-a="4" style={{ opacity: 0 }}>
        {m.pro_user_appreciation_letter_bald_cypress_body4()}
      </p>
      <p data-a="5" style={{ opacity: 0 }} className="mt-[18px]">
        {m.pro_user_appreciation_letter_bald_cypress_body5()}
      </p>
    </motion.div>
  )
}
